import { Component, OnInit, Inject, TemplateRef } from '@angular/core';
import { Users, pairText } from '../models/users';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';

import { AdminService } from '../services/admin.service';
import { ToastrUtilsService } from '../services/toastr-utils.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UserIdleService } from 'angular-user-idle';
import { DOCUMENT } from '@angular/common';
import { UserService } from '../services/user.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { MasterMOMService } from '../services/master-mom.service';
import { usermaster } from '../models/admin';
import { UtilityService } from '../services/utility.service';
import { NgRecaptcha3Service } from "ng-recaptcha3";
import { RSAHelper } from '../models/RSAHelper';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-externallogin',
  templateUrl: './externallogin.component.html',
  styleUrls: ['./externallogin.component.css'],
  providers: [ToastrUtilsService]
})
export class ExternalloginComponent implements OnInit {
  modalFPassword: BsModalRef;
  modalRef: BsModalRef;
  loginForm: FormGroup;
  submitted: boolean = false;
  isforgot: boolean = false;
  GeneralInfoID = 0;
  invalid: boolean = false;
  user: Users;
  usermodel: any = {};
  isError: boolean = false;
  returnUrl: string = '';
  loading = false;
  languages: any[];
  signintext: string = 'SIGN IN';
  isPageLoad: boolean = false;
  isPageSwitch: boolean = false;
  userRights_data: any;
  pageType: string = "";
  generalInfoID: number = 0;
  public ngbModalOptions: any = {
    backdrop: 'static',
    keyboard: false
  };
    model: any;
    lockedCount: any=0;
    strK1: any;
  strI1: any;
  recapchaToken: string = '';
  constructor(@Inject(DOCUMENT) private document: Document,
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private userIdle: UserIdleService,
    private toastr: ToastrUtilsService,
    private userService: UserService,
    private _utilityService: UtilityService,
    private _activatedRoute: ActivatedRoute,
    private router: Router,
    public momMasterservice: MasterMOMService,
    public restApi: AdminService,
    private recaptcha3: NgRecaptcha3Service) { }


  ngAfterViewInit(): void {

    this._activatedRoute.queryParams.subscribe((params: Params) => {
      let QMId = params['QMId'];
      let QMType = params['QMType'];
      
      this.generalInfoID = (QMId && QMId != '') ? Number(atob(QMId.replace(' ', '+'))) : 0;
      this.pageType = (QMType && QMType != '') ? atob(QMType) : "0";
      if (this.generalInfoID > 0 && localStorage.getItem('userinfo')) {
        this.router.navigate(['/meetingofminutes'], { queryParams: { QMId: btoa(this.generalInfoID.toString()), QMType: btoa(this.pageType) } });
        this.document.body.classList.remove('login-screen');
      }
      else {

      }

    });
    window.scroll(0, 0);
  }

  ngOnInit() {
    if(environment.iscaptcharequired==true){
      this.loadpairText();
    }
    
    this.document.body.classList.add('login-screen');
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  loadpairText() {
    ;
    let inpValue = new pairText();
    inpValue.k1 = '';
    this.restApi.callpairText(inpValue)
      .subscribe(data => {
        ;
        let rtnData: pairText;
        rtnData = data;
        this.strK1 = rtnData.k1;
        this.strI1 = rtnData.i1;
        this.recaptcha3.init(rtnData.sik);
      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
  get f() { return this.loginForm.controls; }
  onSubmit() {
    
    this.invalid = false;
    this.submitted = true;
    this.isforgot = false;
    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }
    else {
      if (this.f.username.value.trim().toLowerCase() != "" && this.f.password.value.trim().toLowerCase() != "") {

        if(environment.iscaptcharequired==true){
          this.recaptcha3.getToken().then(
            tv => {
              ;
              this.AdLogin(tv);
            },
            error => {
               
              this.toastr.ErrorCustomMessage('Please enter all required fields');
            }
          );
        }
        else{
          this.AdLogin('Auto');
        }       
      }
      else {
        this.invalid = true;
      }
    }
  }

  //Authendicate Ad user
  AdLogin(tv:string) {  
    if (this.lockedCount == 5) {
      let objUser = new usermaster();
      objUser.userName = this.f.username.value.trim();
      objUser.condition = 4;
      objUser.confirmPassword = '';
      objUser.password = '';
      objUser.userUno = 0;
      objUser.tv = tv;
      this.momMasterservice.resetPassword(objUser)
        .subscribe(data => {
          if (data == "success") {
            this.lockedCount = 0;
            this.toastr.ErrorCustomMessage('Please enter the valid email or contact your system administrator.')
          }
          else {
            this.toastr.ErrorCustomMessage('Please enter the valid email or contact your system administrator.')
          }
        },
          () => {
          
          }
        ).add(() => {
          
        });
     
      return;
    }
    let objusers = new Users;
    this.isError = false;
    var objRSAHelper = new RSAHelper();


    ////Subsidery integration
    // if(environment.isPingEnable==true){
    //   if (this.f.username.value.trim().indexOf('@') <= 0 || this.f.username.value.trim().indexOf('@dewa.gov.ae') >=0) {
    //     this.toastr.ErrorCustomMessage('Dewa/Subsidery users kindly use ONEID login..');
    //     return;
    //   }
    // }


if (environment.isPingEnable) {
  const username = this.f.username.value.trim().toLowerCase();

  const blockedDomains = [
    '@dewa.gov.ae',
    '@digitaldewa.ae',
    '@digital.dewa.gov.ae',
    '@thedigitalx.ae',
    '@morohub.com',
    '@infrax.ae'
  ];

  const hasAtSymbol = username.includes('@');
  const isBlockedDomain = blockedDomains.some(domain =>
    username.endsWith(domain)
  );

  if (!hasAtSymbol || isBlockedDomain) {
    this.toastr.ErrorCustomMessage(
      'Dewa/Subsidery users kindly use ONEID login.'
    );
    return;
  }
}
   


    var userName = objRSAHelper.encryptWithPublicKey(this.f.username.value.trim());
    var password = objRSAHelper.encryptWithPublicKey(this.f.password.value.trim());
    objusers.userName = userName;
    objusers.password = password;
    objusers.tenantUno = 1;
    this.loading = true;
    objusers.tv = tv;
    this.restApi.AdUserAuthenticate(objusers).subscribe(
      data => {
        ;
        //let objdata: any = data;
        
        let rtndata: any = data;
        let objdata: any = [];

        objdata = rtndata.data[0];
        this.user = objdata;
        this.isError = (objdata.error != "" && objdata.error != null) ? true : false;
        if (!this.isError) {
          sessionStorage.setItem('accessinfo', '{"token":"' + objdata.token + '"}');
          objusers.emailId = objdata.emailId;
          //load user property values
          this.restApi.GetUserInfo_ByUserID(objusers).subscribe(
            (data:any) => {

              let objdata: any = data;
              if (objdata != null && objdata.length > 0 && objdata[0] != null) {

                //Get User default information
                var userid = data[0].id;
                var displayname = (data[0].displayName != null && data[0].displayName != '') ? data[0].displayName : '';
                var username = (data[0].userName != null && data[0].userName != '') ? data[0].userName : '';
                var firstname = (data[0].firstName != null && data[0].firstName != '') ? data[0].firstName : '';
                var lastname = (data[0].lastname != null && data[0].lastname != '') ? data[0].lastname : '';
                var email = (data[0].emailId != null && data[0].emailId != '') ? data[0].emailId : '';
                var userPRnumber = (data[0].userPRnumber != null && data[0].userPRnumber != '') ? data[0].userPRnumber : '';
                var isTBT = (data[0].isTBT != null && data[0].isTBT != '') ? data[0].isTBT : false;
                var division = (data[0].division != null && data[0].division != '') ? data[0].division : '';
                var designation = (data[0].designation != null && data[0].designation != '') ? data[0].designation : '';
                var role = (data[0].role != null && data[0].role != '') ? Number(data[0].role) : 0;
                var picture = (data[0].picture != null && data[0].picture != '') ? data[0].picture : '';
                //Assign User value to the Session
                var struser = '{"id":"' + userid + '","displayname":"' + displayname + '","username":"' + username + '","firstname":"' + firstname + '","lastname":"' + lastname + '","email":"' + email + '","isTBT":"' + isTBT + '","division":"' + division + '","picture":"' + picture + '","role":"' + role + '","designation":"' + designation + '","userPRnumber":"' + userPRnumber + '"}';
                localStorage.removeItem('userinfo');
                localStorage.setItem('userinfo', struser);

                let uName = this.f.username.value.toLowerCase();
                let headerImage = '';
                if (uName.indexOf("@thedigitalx.ae") >= 0) {
                  headerImage = this.userService.digitalxLogo;;
                  //headerImage = '/assets/v2/img/digitalx-logo.png';
                  this.userService.changeHeaderLogo(headerImage, 1);
                  this.userService.headerLogo = this.userService.digitalxLogo;
                }
                else if (uName.indexOf("@digital.dewa.gov.ae") >= 0) {
                  headerImage = this.userService.digitalDewaLogo;;
                  //headerImage = '/assets/v2/img/digital-dewa-logo.png';
                  this.userService.changeHeaderLogo(headerImage, 2);
                  this.userService.headerLogo = this.userService.dewaLogo;
                }
                else if (uName.indexOf("@morohub.com") >= 0) {
                  headerImage = this.userService.moroLogo;
                  //headerImage = '/assets/v2/img/moro-logo.png';
                  this.userService.changeHeaderLogo(headerImage, 3);
                  this.userService.headerLogo = this.userService.moroLogo;
                }
                else if (uName.indexOf("@infrax.ae") >= 0) {
                  headerImage = this.userService.infraxLogo;;
                  //headerImage = '/assets/v2/img/infrax-logo.png';
                  this.userService.changeHeaderLogo(headerImage, 4);
                  this.userService.headerLogo = this.userService.infraxLogo;
                }
                else {
                  headerImage = this.userService.dewaLogo;
                  //headerImage = '/assets/v2/img/dewa-logo.png';
                  this.userService.changeHeaderLogo(headerImage, 0);
                  this.userService.headerLogo = this.userService.dewaLogo;
                }
                localStorage.removeItem('headerLogo');
                localStorage.setItem('headerLogo', this.userService.headerLogo);
                this.userService.changeMemberPhoto(picture);
                ;
                var imgprof: any = document.getElementById("imgProfile")
                if (imgprof) imgprof.src = picture;

                var elementElBacktoTop = document.getElementById('elbacktotop') as HTMLInputElement;
                if (elementElBacktoTop != null) {
                  elementElBacktoTop.style.display = "block";
                }

                ;
                var imgprof:any = document.getElementById("imgProfile")
                if (imgprof) imgprof.src = picture;

                var elementElBacktoTop = document.getElementById('elbacktotop') as HTMLInputElement;
                if (elementElBacktoTop != null) {
                  elementElBacktoTop.style.display = "block";
                }
                

                setTimeout(() => {
                  this.loading = false;
                  this.document.body.classList.remove('login-screen'); 
                  this.initServiceCalls();
                  var elementSideBarReport = document.getElementById('sideBarReport') as HTMLInputElement;
                  if (elementSideBarReport != null) {
                    elementSideBarReport.style.display = (role == 1) ? "block" : "none";
                  }
                  var elementsideBarSettings = document.getElementById('sideBarSettings') as HTMLInputElement;
                  if (elementsideBarSettings != null) {
                    elementsideBarSettings.style.display = (role == 1) ? "block" : "none";
                  }
                  var elementheaderSettings = document.getElementById('headerSettings') as HTMLInputElement;
                  if (elementheaderSettings != null) {
                    elementheaderSettings.style.display = (role == 1) ? "block" : "none";
                  }
                }, 1000);

                this.getGroup(); 
              }
              else {
                this.loading = false;
                this.toastr.ErrorCustomMessage('Please enter the valid email or contact your system administrator.')
              }
            },
            error => {
              this.loading = false;
              this.toastr.ErrorCustomMessage('SQL or Network connectivity error is occured,  contact your system administrator.');
             
            },
            () => {
              //'onCompleted' callback.
              this.loading = false;
             
            });

        }
        else {
          this.lockedCount = this.lockedCount + 1;
          this.loading = false;
          this.isforgot = false;
          if (this.f.username.value.trim().indexOf('@') >= 0 && !(this.f.username.value.trim().indexOf('@dewa.gov.ae') >= 0)) {
            this.isforgot = true;
          }
          this.toastr.ErrorCustomMessage('Invalid user name or password. Please try again later or contact your system administrator.');
         
        }
      },
      error => {
        this.lockedCount = this.lockedCount + 1;
        this.loading = false;
        this.isforgot = false;
        if (this.f.username.value.trim().indexOf('@') >= 0 && !(this.f.username.value.trim().indexOf('@dewa.gov.ae') >= 0)) {
          this.isforgot = true;
        }
        this.toastr.ErrorCustomMessage('Invalid user name or password. Please try again later or contact your system administrator.');
       
      },
      () => {
        //'onCompleted' callback.
        this.loading = false;
       
      })



  }
  getGroup() {
    this._utilityService.setProfileObs("login success");
  }
  initServiceCalls() {
    this.userIdle.startWatching();
    
    if (this.generalInfoID > 0 && localStorage.getItem('userinfo')) {

      this.router.navigate(['/view-page'], { queryParams: { QMId: btoa(this.generalInfoID.toString()), QMType: btoa(this.pageType) } });
    }
    else {
      this.router.navigate(['/dashboard']);
    }

  }

  openForgotPasswordModal(template: TemplateRef<any>) {
    
    this.modalFPassword = this.modalService.show(template, Object.assign({}, { class: 'modal-md' }, this.ngbModalOptions));

  }

  forgotPassWord() {
    ;
    let objusers = new Users;
    var userName = this.f.username.value.trim();
    objusers.userName = userName;
    objusers.password = '';
    objusers.condtion = 1;
    this.restApi.forgotPassWord(objusers)
      .subscribe(data => {
        ;
        
        //console.log(data, "userNameCheck");
      },
        (error) => {
         
          // this.spinner.hide();
        }
      ).add(() => {
       
        ///this.spinner.hide();
      });
    this.toastr.SuccessCustomMessage("Successfully sent");
    this.modalFPassword.hide();
  }

openModalnewMeeting(template1: TemplateRef<any>) {

    this.modalRef = this.modalService.show(template1, Object.assign({}, { class: 'gray modal-md modal-full' })
    );
  }
  
  
}

